if (!customElements.get('read-more')) {
  customElements.define('read-more', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.collection-description__toggle');
      this.content = this.querySelector('.collection-description__content');
      if (!this.button) return;

      // Character count can't account for screen width: hide toggle if text already fits
      if (this.content.scrollHeight <= this.content.clientHeight + 2) {
        this.classList.remove('is-collapsible');
        this.button.remove();
        return;
      }
      this.button.addEventListener('click', () => this.toggle());
      // Expand if a keyboard user tabs into a link inside the hidden portion
      this.content.addEventListener('focusin', () => this.toggle(true));
    }

    toggle(forceOpen) {
      const open = forceOpen ?? !this.classList.contains('is-expanded');
      this.classList.toggle('is-expanded', open);
      this.button.setAttribute('aria-expanded', String(open));
      this.button.textContent = open ? this.dataset.less : this.dataset.more;
      if (!open) this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  });
}